export default "__VITE_ASSET__D$MGVYFD__"